import { render, staticRenderFns } from "./NicheAreaDetail.vue?vue&type=template&id=24e86de0&scoped=true"
import script from "./NicheAreaDetail.vue?vue&type=script&lang=js"
export * from "./NicheAreaDetail.vue?vue&type=script&lang=js"
import style0 from "./NicheAreaDetail.vue?vue&type=style&index=0&id=24e86de0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24e86de0",
  null
  
)

export default component.exports